export default __webpack_public_path__ + "static/media/empty.02cfdd21.mp3";